const IPOUserNavigationRoutes = {
  IPO_HOME: "/",
  IPO_APPLICATION_STATUS: "/status",
} as const;

export default IPOUserNavigationRoutes;
